import React from 'react';
import { FormattedMessage } from 'react-intl';
import AlertBox from 'components/ui/AlertBox';
import { StyledAlertBox } from '../Leg.styles';
import { legShape } from 'constants/propTypes';
import { getLoyaltyPromoPeriod } from 'utils/loyaltyData';
import moment from 'moment';

const LoyaltyPromoTicketsAlertBox = ({ journey }) => {
  const isLoyaltyJourney = journey.activeBookingItems.some((item) => item.code.startsWith('LOYALTY') || item.code.startsWith('TH_MILES'));
  let promoPeriod = null;

  for (const item of journey.activeBookingItems) {
    const period = getLoyaltyPromoPeriod({ isLoyalty: isLoyaltyJourney, confirmedTimestamp: item.confirmedTimestamp });

    if (period) {
      promoPeriod = period;
      break;
    }
  }

  if (isLoyaltyJourney && !!promoPeriod) {
    return (
      <StyledAlertBox variant={AlertBox.variants.WARNING}>
        <FormattedMessage
          id="afterSales.loyaltyPromoWarningTicketLevel"
          values={{
            PROMO_START_DATE: moment.utc(promoPeriod.start, moment.ISO_8601).format('ddd Do MMMM YYYY'),
            PROMO_END_DATE: moment.utc(promoPeriod.end, moment.ISO_8601).format('ddd Do MMMM YYYY')
          }}
        />
      </StyledAlertBox>
    );
  }

  return null;
};

LoyaltyPromoTicketsAlertBox.propTypes = {
  journey: legShape.isRequired
};

export default LoyaltyPromoTicketsAlertBox;
